import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { WebApp } from './WebApp';

import './index.css';


const root = ReactDOM.createRoot(
  document.getElementsByTagName('body')[0] as HTMLElement
);

root.render(<WebApp/>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
